module.exports = __webpack_public_path__ + "img/top.d896a757.jpg";